import { render, staticRenderFns } from "./LessonClass.vue?vue&type=template&id=465f0f48&scoped=true&"
import script from "./LessonClass.vue?vue&type=script&lang=ts&"
export * from "./LessonClass.vue?vue&type=script&lang=ts&"
import style0 from "./LessonClass.vue?vue&type=style&index=0&id=465f0f48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465f0f48",
  null
  
)

export default component.exports